<script setup lang="ts">
import { IconArrowLeft } from '@tabler/icons-vue';

defineProps<{ brandUrl: string }>();
</script>

<template>
    <div class="p-xl" style="padding-bottom: 0">
        <a :href="brandUrl" class="row gap-xxs text-sm weight-medium">
            <IconArrowLeft class="icon" />
            Back to eMedici.com
        </a>
    </div>

    <router-view />
</template>
